import { ConnectionStatus } from './ConnectionStatus';
import { CurrentDateTime } from './CurrentDateTime';

export function TopBar() {
  return (
    <header className="border-b border-slate-200 bg-white shadow-[0_1px_0_rgba(15,23,42,0.02)]">
      <div className="mx-auto flex h-[72px] w-full max-w-[1500px] items-center gap-3 px-3 sm:px-5 lg:px-6">
        <div className="flex min-w-0 items-center gap-3">
          <div className="h-12 w-12 shrink-0 overflow-hidden rounded-xl bg-[#00549C]">
            <img
              src="/pwa-192x192.png"
              alt="BABS Laundry Shop"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="min-w-0">
            <p className="truncate text-sm font-black text-[#003B70] sm:text-base">
              BABS Laundry Shop
            </p>
            <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#00549C]">
              Point of Sale
            </p>
          </div>
        </div>

        <div className="ml-auto flex items-center gap-2 sm:gap-3">
          <div className="hidden xl:block">
            <CurrentDateTime />
          </div>
          <ConnectionStatus />
        </div>
      </div>
    </header>
  );
}
